import { Avatar, List, ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText, Button, IconButton } from "@material-ui/core";
import React, { useState, useEffect, useMemo, memo } from "react";
import { connect } from "react-redux";
import EventLabel2, { init } from "../../../components/EventLabel2/EventLabel2";
import { combineProps } from "../../../helpers/objectHelper";
import { clientTypeConstants } from "../../../interaction/constants/clientType.constants";
import SystemLabel from "../../../system/SystemLabel/SystemLabel";
import { OnlineBadge } from "../../components/shared/OnlineBadge";
import { Searchbar } from "../../components/shared/Searchbar";
import { ScrollWrapper } from "../../helpers/module.helper";
import { backstageListStyle, clientListStyle } from "./clientList.helper";
import PersonRoundedIcon from "@material-ui/icons/PersonRounded";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import { PersonInformationPopover } from "../ChatModule/components/shared/PersonInformationPopover";
import HighlightIcon from "@material-ui/icons/Highlight";
import ReactEternalList from "../../../components/ReactEternalList/ReactEternalList";
const mockPeople = [
  {
    name: "Clark Kent",
    nameInitials: "CK",
    badgeNo: "A",
    company: "Daily Planet",
  },
  {
    name: "Bruce Wayne",
    nameInitials: "BW",
    badgeNo: "B",
    company: "Wayne Enterprises",
  },
  {
    name: "Diana Prince",
    nameInitials: "DP",
    badgeNo: "C",
    company: "Justice League",
  },
];
const ClientListModule = memo(({ hubConnection, orderList = [], connectionList = [], backstage = false, channel, backstageConns = false, lang, template, eventId, preview, settings }) => {
  const [filter, setFilter] = useState("");
  // const { orderList, connectionList, lang, template, eventId, preview } = props;
  const [currentSpotlights, setCurrentSpotlights] = useState([]);
  useEffect(() => {
    init(eventId, "DigitalMeeting.ClientList", lang);
    if (hubConnection && !preview) {
      hubConnection.invoke("vonageGetSpotlights", eventId, channel || null);
    }
  }, []);
  useEffect(() => {
    if (hubConnection && !preview) {
      hubConnection.on("onVonageGetSpotlights", onVonageGetSpotlights);
    }
    return () => {
      if (hubConnection && !preview) {
        hubConnection.off("onVonageGetSpotlights", onVonageGetSpotlights);
      }
    };
  });
  function onSpotlightClick(badgeNo, add) {
    if (hubConnection && add) {
      hubConnection.invoke("vonageAddToSpotlight", eventId, channel, badgeNo);
      currentSpotlights.push(badgeNo);
      setCurrentSpotlights([...currentSpotlights]);
    } else if (hubConnection && !add) {
      hubConnection.invoke("vonageRemoveFromSpotlight", eventId, channel, badgeNo);
      setCurrentSpotlights(currentSpotlights.filter((x) => x == badgeNo));
    }
  }
  function onVonageGetSpotlights(spotlightList) {
    setCurrentSpotlights(spotlightList);
  }
  const api = {
    setFilter,
    hubConnection,
    filter,
    preview,
    connectionList,
    channel,
    template,
    backstage,
    backstageConns,
    orderList,
    currentSpotlights,
    onSpotlightClick,
    settings,
    eventId,
    clientListTemplate: backstage ? backstageListStyle : clientListStyle(template),
  };

  return <ClientListContainer {...api} />;
});
function mapStateToProps(state) {
  return {
    template: state.template.template ? state.template.template.content : null,
  };
}
export default connect(mapStateToProps)(ClientListModule);

const ClientListContainer = memo(
  ({ currentSpotlights, onSpotlightClick, connectionList, channel, template, backstage, backstageConns, filter, setFilter, clientListTemplate, orderList, preview, settings = {}, eventId }) => {
    const { header, avatar, frame, list, listItem, searchbar } = clientListTemplate;
    const { name, company } = listItem;
    const { borderTop, borderBottom } = searchbar;
    const { display = "connected", booked = "off", bookedEventId = 0, showSearchbar = true, showAvatar = true, showTitle = true } = settings;
    const clientList = useMemo(() => {
      if (preview) return mockPeople;
      return connectionList.filter(
        (cl) =>
          cl.type == (backstageConns ? clientTypeConstants.INTERACTION_VONAGE_SPEAKER : clientTypeConstants.INTERACTION_MEETING) &&
          (backstageConns ? cl.channel == (channel ? channel + "_BACKSTAGE" : "_BACKSTAGE") : cl.channel == channel)
      );
    }, [channel, connectionList]);

    const people = useMemo(() => {
      if (preview) return mockPeople;
      if (display === "all") {
        return orderList
          .filter((ia) => {
            if (ia.anonymous == true) return false;
            if (ia.orderId == 1 || ia.orderId == 2) return false
            if (booked === "current") return ia.bookedBreakouts.indexOf(eventId) > -1;
            else if (booked === "breakout") return ia.bookedBreakouts.indexOf(bookedEventId) > -1;
            else return true;
          })
          .filter((ia) => {
            if (ia.name.toLowerCase().includes(filter.toLowerCase()))  return true;
            if (ia.company && ia.company.toLowerCase().includes(filter.toLowerCase())) return true;
          })
          .sort(function (a, b) {
            if (a.name < b.name) return -1;
            if (a.name > b.name) return 1;
            return 0;
          });
      }
      return orderList
        .filter((ia) => {
          if (ia.anonymous == true) {
            return false;
          }

          if (ia.name.toLowerCase().includes(filter.toLowerCase()) && clientList.find((c) => c.clientKey == ia.badgeNo)) {
            return true;
          }

          if (ia.company && ia.company.toLowerCase().includes(filter.toLowerCase()) && clientList.find((c) => c.clientKey == ia.badgeNo)) {
            return true;
          }
        })
        .sort(function (a, b) {
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }
          return 0;
        });
    }, [filter, orderList, clientList, listItem, currentSpotlights, settings]);
    const spotlightChangeKey = useMemo(() => {
      return Date.now();
    }, [currentSpotlights, settings]);
    return (
      <div
        style={{
          ...frame,
          background: header.background,
          width: "100%",
          height: "100%",
          display: "flex",
          position: "relative",
          zIndex: preview ? -1 : undefined,
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        {!backstage && showTitle ? (
          <div
            style={{
              ...header,
              padding: "10px 15px",
              fontFamily: header.fontFamily,
            }}
          >
            <EventLabel2 name="ConnectedUsers" groupName="DigitalMeeting.ClientList" />
          </div>
        ) : (
          <div style={{ marginBottom: 10 }} />
        )}
        {showSearchbar ? (
          <div style={{ background: header.background, borderTop, borderBottom }}>
            <Searchbar style={searchbar} filter={setFilter} />
          </div>
        ) : null}

        <ScrollWrapper template={template} backstage={backstage}>
          <List
            className="jir-scroll"
            style={{
              paddingTop: 0,
              overflowY: "auto",
              borderRadius: "inherit",
              height: "100%",
              background: list.background,
            }}
          >
            <ReactEternalList
              list={people.map((p) => {
                const personHasSpotlight = currentSpotlights && currentSpotlights.length > 0 && currentSpotlights.includes(p.badgeNo);
                return { ...{ attendee: p, clientListTemplate, preview, personHasSpotlight, backstage, onSpotlightClick, showAvatar } };
              })}
              preview={preview}
              changeKey={spotlightChangeKey}
              clientListTemplate={clientListTemplate}
              updateRate={100}
              component={ClientListItem}
              compareParam={"badgeNo"}
            />
          </List>
        </ScrollWrapper>
      </div>
    );
  }
);

const ClientListItem = ({ attendee, clientListTemplate, preview, onSpotlightClick, personHasSpotlight, backstage, showAvatar }) => {
  const { avatar, listItem, searchbar } = clientListTemplate;
  const { company, name } = listItem;
  return (
    <ListItem key={attendee.badgeNo} style={{ ...listItem, margin: `${listItem.margin} auto`, paddingTop: "0px", paddingBottom: "0px" }}>
      {showAvatar ? <ListItemAvatar>
        <Avatar src={attendee.profileImage} style={{ ...avatar }}>
          <PersonRoundedIcon />
        </Avatar>
      </ListItemAvatar> : null}
      <ListItemText
        secondary={
          <span title={attendee ? attendee.company : null} className="ellipsis" style={{ ...company }}>
            {attendee ? attendee.company : null}
          </span>
        }
        primary={
          <span title={attendee ? attendee.name : <SystemLabel name="Guest" />} className="ellipsis" style={{ ...name }}>
            {attendee ? attendee.name : <SystemLabel name="Guest" />}
          </span>
        }
      />
      {!preview && attendee.linkedIn ? (
        <ListItemSecondaryAction>
          <Button
            onClick={() => window.open(attendee.linkedIn, "_blank")}
            variant="contained"
            color="default"
            style={{
              backgroundColor: "#eee",
              padding: "6px 12px",
              margin: 5,
              boxShadow: "none",
            }}
          >
            <LinkedInIcon />
          </Button>
        </ListItemSecondaryAction>
      ) : null}
      {!preview && backstage ? (
        <ListItemSecondaryAction>
          <IconButton
            onClick={() => onSpotlightClick(attendee.badgeNo, !personHasSpotlight)}
            style={{
              backgroundColor: personHasSpotlight ? "#20a8d8e0" : undefined,
              color: personHasSpotlight ? "#fff" : "#ffffff99",
              padding: "8px",

              margin: 5,
              // boxShadow: "none",
            }}
            edge="end"
          >
            <HighlightIcon />
          </IconButton>
        </ListItemSecondaryAction>
      ) : null}
    </ListItem>
  );
};
